export const BASE_EXTRA_DATA = {
    cC: "pl",
    bR: "otomoto",
    business_model: "lease",
    language: "pl_PL",
    user_status: "unlogged",
};
